import EpisodeParts from './EpisodeParts';

export default EpisodeParts;
